export enum Headers {
  ANREDE_VN = "Anrede VN",
  ANREDE_HALTER = "Anrede Halter",
  ANREDE_BEITRAGSZAHLER = "Anrede Beitragszahler",
  RECHTSFORM_VN = "Rechtsform VN",
  RECHTSFORM_HALTER = "Rechtsform Halter",
  GEWÜNSCHTER_VERSICHERUNGSSCHUTZ = "Gewünschter Versicherungsschutz",
  SELBSTBETEILIGUNG_TEILKASKO = "Selbstbeteiligung Teilkasko",
  SELBSTBETEILIGUNG_VOLLKASKO = "Selbstbeteiligung Vollkasko",
  EIGENTUMSVERHAELTNIS_ZUM_FAHRZEUG = "Eigentumsverhaeltnis zum Fahrzeug",
  ABWEICHENDER_BEITRAGSZAHLER = "Abweichender Beitragszahler",
  VORSTEUERABZUGSBERECHTIGUNG_VN = "Vorsteuerabzugsberechtigung VN",
  ABWEICHENDER_HALTER = "Abweichender Halter",
  ZAHLUNGSWEISE = "Zahlungsweise",
  ZAHLUNGSART = "Zahlungsart",
  SAISONKENNZEICHEN = "Saisonkennzeichen",
  SFKLASSE_HAFTPFLICHT = "SFKlasse Haftpflicht",
  SFKLASSE_VOLLKASKO = "SFKlasse Vollkasko",
  BETRIEBSAUSGABE = "Betriebsausgabe",
  SAISONKENNZEICHEN_DER_VORVERSICHERUNG = "Saisonkennzeichen der Vorversicherung",
  SCHUTZBRIEF = "Schutzbrief",
  AUSLANDSSCHADENSCHUTZ = "Auslandsschadenschutz",
  FAHRERPLUS_FAHRERSCHUTZ = "FahrerPlus-FahrerSchutz",
  RABATTSCHUTZ = "Rabattschutz",
  AUTONOTRUF = "AutoNotruf",
  BONUSDRIVE = "BonusDrive",
  BEITRAGSSCHUTZ = "Beitragsschutz",
  WERTERHALTGARANTIE = "WerterhaltGarantie",
  PRODUKTLINIE = "Produktlinie",
  WERKSTATTBONUS = "WerkstattBonus"
}
